import React, {useContext, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Input from '@material-ui/core/Input';
import html2canvas from 'html2canvas';
import CircularProgress from '@material-ui/core/CircularProgress';
import PatientInfo from "./PatientInfo";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import jsPDF from 'jspdf';
import Checkbox from '@material-ui/core/Checkbox';
import { AuthorizeContext } from "../../RootContext";
import { api_url } from "../../authorize";
import { CaseFormDataContext } from './CreateCaseContext';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import { Link, Redirect } from "react-router-dom";

import logo from '../../img/lento_logo.jpg'

import { makeStyles } from '@material-ui/core/styles';

var pdf, pdfFile, allData;

const useStyles = makeStyles(theme => ({
  button:{
    fontSize: "1.5em",
    float: "right",
    margin: "10px 30px 10px 10px"
  },
  textField: {
    fontSize: 14,
    marginTop: '1em',
    margin: 'auto',
    // paddingBottom: '-10px',
    paddingTop: '1em',
  },
  resize:{
    // padding: '1em',
    // paddingBottom: '-1em',
    fontSize:14
  },
  initial: {
    fontSize: 14,
    paddingLeft: "auto",
    paddingRight: "auto",
    textTransform: "uppercase"
  },
  signature: {
    fontSize: 14,
    // paddingBottom: '1em',
    // padding: '1em',
    fontStyle: 'italic'
  }
}));

const ConsentFormITA = () => {
  const classes= useStyles();
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [screenshotted, setScreenshotted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [created, setCreated] = useState(false);
  const { token, setAuthenticated, setAuthBody, user } = useContext(AuthorizeContext);
  const context = useContext(CaseFormDataContext);
  const { step, setState, prevStep, nextStep, formData, editPref } = context;
  let alignment, screenshot;
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let caseData =
  {
    "Surgeon": {
      "First_Name": context.formData.First_Name,
      "Middle_Name": context.formData.Middle_Name,
      "Last_Name": context.formData.Last_Name,
      "Office_Name": context.formData.Office_Name,
      "Country": context.formData.Country,
      "City": context.formData.City,
      "Postal_Code": context.formData.Postal_Code,
      "Street": context.formData.Street,
      "State_Province": context.formData.State_Province,
      "Email_Address": context.formData.Email_Address,
      "Phone": context.formData.Phone,
      "Fax": context.formData.Fax,
    },
    "Distributor": {
      "First_Name": context.formData.Distributor_First_Name,
      "Middle_Name": context.formData.Distributor_Middle_Name,
      "Last_Name": context.formData.Distributor_Last_Name,
      "Office_Name": context.formData.Distributor_Office_Name,
      "Country": context.formData.Distributor_Country,
      "City": context.formData.Distributor_City,
      "Postal_Code": context.formData.Distributor_Postal_Code,
      "Street": context.formData.Distributor_Street,
      "State_Province": context.formData.Distributor_State_Province,
      "Email_Address": context.formData.Distributor_Email_Address,
      "Phone": context.formData.Distributor_Phone,
      "Fax": context.formData.Distributor_Fax,
    },
    "Hospital": {
      "First_Name": context.formData.Hospital_First_Name,
      "Middle_Name": context.formData.Hospital_Middle_Name,
      "Last_Name": context.formData.Hospital_Last_Name,
      "Office_Name": context.formData.Hospital_Office_Name,
      "Country": context.formData.Hospital_Country,
      "City": context.formData.Hospital_City,
      "Postal_Code": context.formData.Hospital_Postal_Code,
      "Street": context.formData.Hospital_Street,
      "State_Province": context.formData.Hospital_State_Province,
      "Email_Address": context.formData.Hospital_Email_Address,
      "Phone": context.formData.Hospital_Phone,
      "Fax": context.formData.Hospital_Fax
    },
    "MRI_Center": {
      "First_Name": context.formData.MRI_Center_First_Name,
      "Middle_Name": context.formData.MRI_Center_Middle_Name,
      "Last_Name": context.formData.MRI_Center_Last_Name,
      "Office_Name": context.formData.MRI_Center_Office_Name,
      "Country": context.formData.MRI_Center_Country,
      "City": context.formData.MRI_Center_City,
      "Postal_Code": context.formData.MRI_Center_Postal_Code,
      "Street": context.formData.MRI_Center_Street,
      "State_Province": context.formData.MRI_Center_State_Province,
      "Email_Address": context.formData.MRI_Center_Email_Address,
      "Phone": context.formData.MRI_Center_Phone,
      "Fax": context.formData.MRI_Center_Fax
    },
    "Patient": {
      "First_Name": context.formData.Patient_First_Name,
      "Last_Name": context.formData.Patient_Last_Name,
      "Middle_Name": context.formData.Patient_Middle_Name ?
      context.formData.Patient_Middle_Name : ""
      ,
      "Email": context.formData.Patient_Email,
      "Sex": context.formData.Patient_Sex,
      "Date_of_Birth": context.formData.Patient_DOB ? context.formData.Patient_DOB.replaceAll("/", "-") : "",
      "Date_of_Surgery": context.formData.Patient_DOS ? context.formData.Patient_DOS.replaceAll("/", "-") : "",
      "Surgery_Type": context.formData.surgeryType,
      "Side_of_Body": context.formData.Patient_Side
    },
    "Billing_Address": context.formData.billing_address,
    "Shipping_Address": context.formData.shipping_address,
    "Implant": context.formData.Implant,
    "Alignment": context.formData.Patient_Alignment ? context.formData.Patient_Alignment :
     context.formData.Pref_Alignment,
     "geo" : context.formData.geo
  }

  const handleClose = () => {
    setChecked(false)
    setLoading(false)
    setState({Patient_Email: false})
    setScreenshotted(false)
    setOpen(false);
  };

  const handleChange = (e) => {
    setChecked(e.target.checked);
  };

  const onChange = (e) => {
    const { name, value } = e.target

      setState({...formData,
          [name] : value
      })

  }
  const handleClickOpen = () => {
      setOpen(true);
  };

  const formArray =
  [
    formData.initial_1,
    formData.initial_2,
    formData.initial_3,
    formData.initial_4,
    formData.initial_5,
    formData.signature

  ]

  const validateEmail = (email) =>
  {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  }


  const handleScreenShot = (e) => {
    setTimeout(screenshot,2000)
    screenshot = document.querySelector("#capture")
    // overwrite owner doc inner height with your div clientHeight
    const imgWidth = 180;
    const pageHeight = 350;
    setChecked(e.target.checked);
    if(!checked){
      html2canvas(screenshot, {useCORS: true, scrollY: 0, backgroundColor: null}).then(
        canvas => {
          const imgData = canvas.toDataURL('image/png');
          const imgHeight = canvas.height * 165 / canvas.width;
          console.log(imgHeight)
          console.log(canvas.height)
          console.log(canvas.width)
          console.log("hibbb")
          let heightLeft = imgHeight
          pdf = new jsPDF("p", "mm");
          let position = 0
          pdf.addImage(imgData, 'PNG', 15, position, imgWidth, imgHeight);
          heightLeft -= pageHeight
          // pdf.output('dataurlnewwindow');
          while (heightLeft >= 0){
            console.log(position)
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 15, position, imgWidth, imgHeight);
            heightLeft -= pageHeight
          }

          pdfFile = pdf.output("blob");
          allData = new FormData();
          allData.append('file', pdfFile, "ok.pdf")
          // allData.append(caseData)
          allData.append('data',JSON.stringify(caseData))
          console.log(...allData)
        }).then(setScreenshotted(true));
    }

  }
  
  console.log(formArray)
  console.log(formArray.includes("" || undefined))
  const handleSubmit = (e) => {
    e.preventDefault()


    console.log(...allData)

    setLoading(true)
    setScreenshotted(false)

    // console.log(options);
    axios({
      method:'post',
      url: `https://${api_url}/api/case`,
        headers: {
          'x-access-token' : token,
          'Content-Type': 'multipart/form-data'
        },
        data: allData

      }).then(res=> {
        if(res.data.message){
          setScreenshotted(false)
          setChecked(false)
          alert(res.data.message.replace("_", " "))
        }
        else if(res.data.validation){
          setLoading(false)
          handleClose()
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setScreenshotted(false)
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{

          setState({case_id: res.data.case_id})
          setCreated(true)

        }
        console.log("me", res.data)
      }).catch(err => {alert(err)
      setScreenshotted(false)
      setChecked(false)
    }
    );
  }
  console.log(context.formData.surgeryType)

  if(created){
    return(
      <Redirect to={`/case/${formData.case_id}`} />
    )
    // console.log(context.formData.case_id)
  }
  return (
    <div>
    <Button variant="contained" color="primary" onClick={handleClickOpen} className={classes.button} disabled={!context.formData.Patient_Last_Name||!context.formData.Patient_First_Name||
    !context.formData.Patient_Sex||!context.formData.Patient_DOB||!context.formData.Patient_DOS||!context.formData.Patient_Side}>
      Accept
    </Button>
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Consent Form Date of Issue: September 02, 2020 - Consent Form version: Rev.: A"}</DialogTitle>
      <div id="capture">
      <DialogContent>
        <img src={logo} width="40%" height="40%" className="center-block" style={{marginTop: '-6em', marginBottom: '-5em'}}/>
        <h4 style={{textAlign:'center', fontWeight: 'bold'}}>PtoleMedic System</h4>
        <h3 style={{textAlign: 'center', fontWeight: 'bold'}}>Data Use Consent Form</h3>
        <DialogContentText id="alert-dialog-description" style={{fontSize: '.83em', color: 'black', fontWeight: 'bold', fontFamily: 'arial'}}>
        <div>
        
        Il Suo chirurgo Le ha comunicato la necessità di una sostituzione articolare di uno o entrambi le ginocchia. 
        Lento Medical Innovation, Inc. (Lento) produce guide chirurgiche personalizzate per assistere il Suo chirurgo nell’eseguire l’intervento. 
        Le guide personalizzate si adattano esclusivamente alla Sua anatomia unica. 
        Il Suo chirurgo progetta le guide utilizzando un software speciale chiamato PtoleMedic System. 
        Poiché Lento utilizza le Sue immagini di Risonanza Magnetica (MRI), 
        è necessario il Suo consenso per l’uso di queste informazioni sanitarie. Sebbene le informazioni utilizzate da Lento siano limitate, 
        si applicano comunque le disposizioni vigenti dei requisiti per i dispositivi medici e del Regolamento Generale sulla 
        Protezione dei Dati (GDPR) dell’Unione Europea. 
        Le Sue informazioni non possono essere utilizzate né consultate senza il Suo consenso esplicito. 
        Per “Dati Personali” si intendono i dati che possono identificarla come individuo.
        </div>
        <br />
        <strong>Le informazioni personali di cui Lento ha bisogno sono:</strong>
         <li>
           Le immagini di Risonanza Magnetica (MRI) della Sua gamba, comprensive di anca, ginocchio e caviglia, 
           contengono il Suo nome, data di nascita (DOB), sesso, nome del chirurgo, ospedale e numero identificativo del caso. 
           Richiediamo inoltre il Suo consenso affinché Lento possa ricevere riscontro riguardante il Suo intervento chirurgico. 
           Le informazioni possono essere trasferite elettronicamente agli ingegneri di Lento negli Stati Uniti d’America (USA) per la pianificazione.
         </li>
         <strong>Le informazioni personali che Lento raccoglie sono limitate a:</strong>
 
          <li>
          Immagini digitali di Risonanza Magnetica (MRI) della gamba da operare (ginocchio, anca e caviglia), diagnosi, 
          nome, età, sesso, nome del chirurgo, ospedale e data dell’intervento, inclusi dati demografici, 
          dati sanitari e immagini MRI con informazioni identificative del paziente.
          </li>
 
        <strong>I Dati Personali raccolti sono utilizzati per le seguenti finalità:</strong>
 
          <li>
          Pianificazione chirurgica per il posizionamento dell’impianto al ginocchio, determinazione della misura dell’impianto, 
          allineamento dell’arto (gamba) e produzione della Guida Chirurgica PtoleKnee.
          </li>
 
        <strong>La base legale per la raccolta e il trattamento dei Dati Personali è: </strong>
 
          <li>
          Esecuzione di un contratto, adempimento di un obbligo legale, 
          protezione di interessi vitali e perseguimento di una finalità legittima per garantire la Sua assistenza e il Suo trattamento.
          </li>
 
        <strong>Gli interessi legittimi perseguiti da noi, inclusi eventuali utilizzi da parte di terzi, sono:  </strong>
      
          <li>
          Pianificazione chirurgica e produzione di guide di taglio personalizzate per il Suo intervento chirurgico.
          </li>
      
        <br />
        <div>
        <strong>Consenso: </strong>
       Con il consenso a questa informativa sulla privacy, Lei autorizza Lento Medical Innovation, Inc. 
       a utilizzare le specifiche informazioni personali e sanitarie per le finalità indicate sopra. 
       Il Suo consenso è necessario affinché Lento Medical Innovation, Inc. possa trattare entrambe le tipologie di informazioni personali, 
       e deve essere fornito in modo esplicito. Quando richiediamo dati sensibili, 
       Lento Le comunica perché e come tali dati vengono utilizzati. 
       Può revocare il consenso all’uso dei Suoi dati in qualsiasi momento compilando e inviando una copia firmata del modulo “Revoca del Consenso”, 
       disponibile tramite il Suo chirurgo o su richiesta diretta a Lento Medical Innovation.
        </div>
        <br />
        <div>
        <strong>Divulgazione: </strong>
         Lento Medical Innovation, Inc. non trasmette i Suoi dati a terzi senza aver prima ottenuto il Suo consenso, 
         come avviene con la presente. Attualmente, le seguenti entità terze potrebbero avere accesso ai Suoi dati per le finalità indicate, 
         come parte del supporto al Suo medico nella fornitura delle cure chirurgiche, del trattamento medico e della registrazione documentale. 
         Le informazioni supportano inoltre finalità analitiche e regolatorie. I nostri dati sono archiviati negli Stati Uniti.
        </div>
        <br />
        <table style={{border: '1px solid black', borderCollapse: 'collapse'}}>
          <tr>
            <th>Germania – UE – Requisiti MDR</th>
            <th>Misure di protezione adottate per tutelare i Suoi Dati Personali</th>
            <th>Verifichi le misure di protezione adottate qui</th>
          </tr>
          <tr>
            <td>Amazon WEB Services (AWS)
            <br/>
            79539 Rippee Road
            Boardman, OR 97818
            <br />
            +11 206-266-4064
            </td>
            <td>AWS Shield - Advanced</td>
            <td>AWS Web site</td>
          </tr>
        </table>
        </DialogContentText>
        <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <div className="col-md-12 mb-5" style={{align: 'center'}}>
          <div className="col-md-4">
          <TextField 
            className={classes.textField}
            placeholder="Nome del paziente:"
            name="patient_name"
            type="text"
            defaultValue={`${context.formData.Patient_Last_Name}, ${context.formData.Patient_First_Name}`}
            size="medium"
            fullWidth
            InputProps={{
              readOnly: true,
              classes: {
                input: classes.initial
              }
            }}
            fullWidth
            helperText="Nome del paziente:"
            required
          />
          </div>
          <div className="col-md-4">
            <TextField
              className={classes.textField}
              placeholder="Data di nascita del paziente:"
              name="patient_name"
              type="text"
              size="medium"
              defaultValue={
                user.Country === "US" ?
                `${formData.Consent_DOB}`
                :
                `${context.formData.Patient_DOB}`}
              fullWidth
              InputProps={{
                readOnly: true,
                classes: {
                  input: classes.initial
                }
              }}
              fullWidth
              helperText="Data di nascita del paziente:"
              required
            />
          </div>
          <div className="col-md-4">
            <TextField
              className={classes.textField}
              placeholder="Nome del chirurgo:"
              name="patient_name"
              type="text"
              size="medium"
              defaultValue= {`${user.Last_Name}, ${user.First_Name}` }
              fullWidth
              InputProps={{
                readOnly: true,
                classes: {
                  input: classes.initial
                }
              }}
              fullWidth
              helperText="Nome del chirurgo:"
              required
            />
          </div>
        </div>
        <br />
        <p>Titolo del consenso: <strong> Autorizzazione Limitata all’Uso delle Informazioni Mediche</strong></p>
          <ol style={{fontSize: '.85em', color: 'black', fontWeight: 'bold', fontFamily: 'arial'}}>
          <li className="col-md-12 mb-3">
          <div className="col-md-9">
         Confermo di aver letto e compreso il opuscolo informativo “Lento PtoleMedic System, Rel. 1.3.1” e la Guida Chirurgica PtoleKnee. 
         Ho avuto l’opportunità di valutare le informazioni, porre domande al mio chirurgo e ricevere risposte soddisfacenti.
          </div>
          <div className="col-md-3">
            <TextField
            placeholder="Initial"
            name="initial_1"
            type="text"
            size="medium"
            required
            inputProps={{
              maxLength: "2"
            }}
            InputProps={{
              classes: {
                input: classes.initial
              },
              onChange: onChange
            }}
            variant="outlined"
            />
          </div>
          </li>
          <br />
          <li className="col-md-12 mb-3">
            <div className="col-md-9">
          <strong>
          Comprendo che il mio consenso è volontario e che sono libero di revocarlo in qualsiasi momento, 
          senza fornire alcuna motivazione, senza che ciò influisca sulle mie cure mediche o sui miei diritti legali.</strong>
            </div>
            <div className="col-md-3">
             <TextField
             placeholder="Initial"
             name="initial_2"
             type="text"
             size="medium"
             required
             inputProps={{
               maxLength: "2"
             }}
             InputProps={{
               classes: {
                 input: classes.initial
               },
               onChange: onChange
             }}
             variant="outlined"
             />
           </div>
          </li>
          <br />
          <li className="col-md-12">
            <div className="col-md-9">
            <strong>
            Comprendo che le sezioni pertinenti delle mie cartelle cliniche e i dati raccolti durante 
            il mio trattamento possono essere consultati da personale di Lento Medical Innovation, Inc., 
            dalle autorità regolatorie locali o dalle autorità UE/MDR, quando ciò sia rilevante per 
            il mio coinvolgimento nell’uso delle guide chirurgiche personalizzate PtoleKnee. 
            Autorizzo Lento Medical Innovation ad accedere ai miei dati come descritto.</strong>
            </div>
            <div className="col-md-3">
              <br />
            <TextField
            placeholder="Initial"
            name="initial_3"
            type="text"
            size="medium"
            required
            inputProps={{
              maxLength: "2"
            }}
            InputProps={{
              classes: {
                input: classes.initial
              },
              onChange: onChange
            }}
            variant="outlined"
            />
           </div>
          </li>
          <br />
          <li className="col-md-12">
            <div className="col-md-9">
            <strong>
            Il mio chirurgo mi ha spiegato i potenziali rischi e i possibili benefici dell’uso del software PtoleMedic System 
            e della Guida Chirurgica PtoleKnee durante il mio intervento al ginocchio, e acconsento al loro utilizzo.</strong>
            </div>
            <div className="col-md-3">
              <br />
              <TextField
              placeholder="Initial"
              name="initial_4"
              type="text"
              size="medium"
              required
              inputProps={{
                maxLength: "2"
              }}
              InputProps={{
                classes: {
                  input: classes.initial
                },
                onChange: onChange
              }}
              variant="outlined"
              />
            </div>
          </li>
          <li className="col-md-12">
            <div className="col-md-9">
          <strong>
          Comprendo e accetto che il mio chirurgo possa decidere di non utilizzare la Guida Chirurgica PtoleKnee 
          durante il mio intervento, qualora lo ritenesse necessario. 
          In tal caso, l’intervento sarà completato secondo le procedure abituali e a discrezione del chirurgo.</strong>
            </div>
            <div className="col-md-3">
            <br />
            <TextField
            placeholder="Initial"
            name="initial_5"
            type="text"
            size="medium"
            required
            inputProps={{
              maxLength: "2"
            }}
            InputProps={{
              classes: {
                input: classes.initial
              },
              onChange: onChange
            }}
            variant="outlined"
            />
            </div>
          </li>
         </ol>
        </div>
        <div className="col-md-12">
          <div className="row">
            <TextField 
              className={classes.textField}
              placeholder="Patient Name"
              helperText="Patient Name"
              name="patient_name"
              defaultValue= {`${formData.Patient_Last_Name}, ${formData.Patient_First_Name}` }
              type="text"
              size="large"
              InputProps={{
              classes: {
                input: classes.resize
              }
            }}
              required
            />
            <Input
            className={classes.textField}
            placeholder="Data"
            name="email"
            helperText="Data"
            defaultValue={
                user.Country === "US" ?
                `${month<10?`0${month}`:`${month}`}/${date<10?`0${date}`:`${date}`}/${year}`

                :
                `${year}/${month<10?`0${month}`:`${month}`}/${date<10?`0${date}`:`${date}`}`
            }
            size="large"
            InputProps={{
              classes: {
                input: classes.resize
              }
            }}
            required
            />
            <TextField
              className={classes.textField}
              placeholder="Firma Paziente"
              name="signature"
              type="text"
              size="medium"
              helperText="Firma Paziente"
              InputProps={{
                classes: {input: classes.signature},
                onChange: onChange
              }}
              required
            />
          </div>
          <div className="row">
            <TextField
              className={classes.textField}
              placeholder="Nome Testimone"
              helperText="Nome Testimone"
              name="witness_name"
              type="text"
              size="large"
              defaultValue= {`${user.Last_Name}, ${user.First_Name}` }
              InputProps={{
                readOnly: true,
                classes: {
                input: classes.resize
              }
              }}
              required
            />
            <Input
            className={classes.textField}
            placeholder="Data"
            name="email"
            defaultValue={
              user.Country === "US" ?
              `${month<10?`0${month}`:`${month}`}/${date<10?`0${date}`:`${date}`}/${year}`

              :
              `${year}/${month<10?`0${month}`:`${month}`}/${date<10?`0${date}`:`${date}`}`

            }
            size="large"
            InputProps={{
              classes: {
                input: classes.resize
              },
              required: true
            }}
            required
            />
            <TextField
              className={classes.textField}
              placeholder="Firma Testimone"
              name="witness_name"
              type="text"
              size="large"
              defaultValue= {`${user.Last_Name}, ${user.First_Name}` }
              InputProps={{
                classes: {input: classes.signature}
              }}
              helperText="Firma Testimone"
              required
            />
          </div>
          <div className="col-md-10">
            <Input
            className={classes.textField}
            placeholder="Paziente Email"
            helperText="Paziente Email"
            onChange={onChange}
            name="Patient_Email"
            type="email"
            size="large"
            fullWidth
            InputProps={{
              classes: {
                input: classes.resize,
                fontSize: '2em'
              }
            }}
            required
            />
          </div>
           
            <FormControlLabel
              value="end"
              control={<Checkbox color="primary" 
                disabled={
                  formArray.some(x => x === "" || x === undefined)

                  ||

                  !validateEmail(formData.Patient_Email)
                }
                />
              }
              label="Acconsento e dichiaro di aver letto il modulo di consenso."
              labelPlacement="end"
            />
            <div>
            <FormControlLabel
              value="end"
              control={<Checkbox color="primary" onChange={handleScreenShot}
                disabled={
                  formArray.some(x => x === "" || x === undefined)

                  ||

                  !validateEmail(formData.Patient_Email)
                }
                />
              }
              label="Non sono un robot"
              labelPlacement="end"
            />
            </div>
            
        </div>
      </DialogContent>
        <div style={{fontSize: '.7em', textAlign: 'center'}}>
        Lento Medical Innovation, Inc.: 15110 Northwest Fwy., Suite 150, Houston, TX, USA
        Phone: +1 510.413.3230 Fax: +1 510.413.7020 email: support@lentomedical.com
        </div>
        <div style={{fontSize: '.6em', textAlign: 'center'}}>
          Consent form date of issue: September 02, 2020 - Consent form version: Rev.: A
        </div>
        <div className="col-md-12">
        </div>
      </div>
      <DialogActions>
        <Button onClick={handleSubmit} disabled={!screenshotted || !checked || loading
          ||

          formArray.some(x => x === "" || x === undefined)

          ||

          !validateEmail(formData.Patient_Email)
        } color="primary" style={{fontSize: '1em'}}>
        {loading ?
          <div>
          Submitting
          <CircularProgress  size={15}/>
          </div>
        : "Submit"}
        </Button>
        <Button onClick={handleClose} color="primary" style={{fontSize: '1em'}}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  </div>
  );
}

export default ConsentFormITA;
